<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { useStore } from '@/stores/store'
import { storeToRefs } from 'pinia'
import { Field } from 'vee-validate'
import { computed, ref } from 'vue'

const store = useStore()
const { buttonsDistribution, buttonsCols, buttonsRows, buttonsDistanceToEdge } = storeToRefs(store)
const MIN_BUTTONS = 1
const MAX_BUTTONS = 20
const MIN_BUTTONS_DISTANCE = ref(5)
const buttons_distance_max_value = ref(100)
const buttonsSimpleSplitRectangleImgPath = store.imgPath + '/size/with-simple-split.jpg'
const buttonsFixedDistanceRectangleImgPath =
  store.imgPath + '/size/with-fixed-distance-to-the-edge.jpg'
// const buttonsFixedDistanceRightImgPath =
//   store.imgPath + '/with-fixed-distance-to-the-edge-right0.png'
// const buttonsFixedDistanceBottomImgPath =
//   store.imgPath + '/with-fixed-distance-to-the-edge-bottom0.png'
const computedButtonRule = computed(
  () => Number(buttonsCols.value) * Number(buttonsRows.value) > MAX_BUTTONS,
)
const maxCols = computed(() => MAX_BUTTONS / Number(buttonsRows.value))
const maxRows = computed(() => MAX_BUTTONS / Number(buttonsCols.value))

function validateButtonsRules(value: unknown) {
  const strValue = String(value);
  if (computedButtonRule.value) {
    return 'Max. 20 buttons (Buttons per row x rows of buttons must not exceed 20). '
  }
  if (!(strValue && strValue.trim())) {
    return 'This field is required'
  }
  return true
}
</script>
<template>
  <transition name="buttons-qty">
    <div class="modal-mask space-y-6 lg:space-y-10" v-if="store.isButtons === 'buttons_yes'">
      <div class="shape-wrapper flex-col">
        <div class="form-padding">
          <span class="topic-position">{{ $t('How do you want the buttons arranged?') }} </span>
        </div>
        <div class="grid grid-cols-2 gap-4">
          <label class="shape-item" for="distribution_simple_split">
            <div class="mb-4">
              <img class="" :src="buttonsSimpleSplitRectangleImgPath" />
            </div>
            <div class="inline-flex gap-2">
              <input
                id="distribution_simple_split"
                v-model="buttonsDistribution"
                required
                type="radio"
                class="radio-input"
                value="distribution_simple_split"
                name="buttonsDistribution"
              />
              <span class="check-text">{{ $t('With simple division') }}</span>
            </div>
          </label>
          <label class="shape-item" for="distribution_fixed_distance">
            <div class="mb-4">
              <img :src="buttonsFixedDistanceRectangleImgPath" />
            </div>
            <div class="inline-flex gap-2">
              <input
                id="distribution_fixed_distance"
                v-model="buttonsDistribution"
                required
                type="radio"
                class="radio-input"
                value="distribution_fixed_distance"
                name="buttonsDistribution"
              />

              <span class="check-text">{{ $t('With fixed distance to the edge') }}</span>
            </div>
          </label>
        </div>
      </div>
      <div class="form-group" v-if="buttonsDistribution !== ''">
        <label for="buttonsCols" class="field-label inline-flex gap-2 justify-center items-center">
          <span class="">{{ $t('Buttons in a row') }}</span>
        </label>
        <Field
          validateOnInput
          v-model="buttonsCols"
          name="buttonsCols"
          :rules="validateButtonsRules"
          type="number"
          v-slot="{ errorMessage, field }"
        >
          <input
            v-bind="field"
            class="!field-input appearance-textfield"
            type="number"
            :min="MIN_BUTTONS"
            :max="maxCols"
            id="buttonsCols"
            :placeholder="$t('Enter the value')"
            inputmode="numeric"
          />
          <span v-if="errorMessage">{{ errorMessage }}</span>
        </Field>
      </div>
      <div class="form-group" v-if="buttonsDistribution !== ''">
        <label for="buttonsRows" class="field-label">{{ $t('Rows of buttons') }}</label>
        <Field
          validateOnInput
          v-model="buttonsRows"
          :rules="validateButtonsRules"
          name="buttonsRows"
          type="number"
          v-slot="{ errorMessage, field }"
        >
          <input
            id="buttonsRows"
            v-bind="field"
            class="!field-input appearance-textfield"
            type="number"
            :min="MIN_BUTTONS"
            :max="maxRows"
            inputmode="numeric"
            :placeholder="$t('Enter the value')"
          />
          <span v-if="errorMessage">{{ errorMessage }}</span>
        </Field>
      </div>
      <div
        class="form-group distance-options"
        v-if="buttonsDistribution === 'distribution_fixed_distance'"
      >
        <label class="items-center" for="buttonsDistanceToEdge">
          <span class="field-label">{{ $t('Distance to edge') }}</span>
          <span class="field-condition">{{ $t('Minimum') }} 5 cm</span>
        </label>
        <div class="relative">
          <input
            id="buttonsDistanceToEdge"
            v-model="buttonsDistanceToEdge"
            class="!field-input appearance-textfield"
            name="buttonsDistanceToEdge"
            type="number"
            min="5"
            inputmode="numeric"
            :placeholder="$t('Enter the value')"
            required
          />
          <span class="absolute right-6 top-1/3 text-black/40">cm</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped></style>
